import styled from 'styled-components';

export const ListingPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;

export const LotCardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 4px;
    margin-left: 28px;
    width: calc(100% - 28px);
`;

export const ListingRowContainer = styled.div`
    align-items: center;
    background: ${({ $selected }) => $selected ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.05)'};
    border: 1px solid ${({ $selected }) => $selected ? 'rgba(255,255,255,0.25)' : 'transparent'};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    gap: 10px;
    padding: 8px 12px;
    transition: all 0.15s ease;

    &:hover { background: rgba(255,255,255,0.10); }
`;

export const ListingNestedRow = styled.div`
    align-items: center;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    display: flex;
    gap: 10px;
    padding: 6px 12px;
`;

export const ListingLotBadge = styled.button`
    align-items: center;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    display: flex;
    flex-shrink: 0;
    height: 32px;
    justify-content: center;
    padding: 0;
    transition: all 0.15s ease;
    width: 24px;

    &:hover {
        background: rgba(255, 255, 255, 0.14);
        color: #fff;
    }
`;

export const RowActions = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 6px;
`;

export const ListingSwatch = styled.div`
    background: ${({ $color }) => $color ?? '#fff'};
    border-radius: 100px;
    flex-shrink: 0;
    height: 32px;
    width: 8px;
`;

export const ListingInfo = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    overflow: hidden;
`;

export const ShippingDropdown = styled.select`
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    color: rgba(255, 255, 255, 0.65);
    cursor: pointer;
    flex-shrink: 0;
    font-family: 'Inter', sans-serif;
    font-size: 10px;
    font-weight: 600;
    height: 26px;
    letter-spacing: 0.03em;
    max-width: 90px;
    outline: none;
    padding: 0 6px;
    text-align: center;
    transition: all 0.15s ease;

    option { background: #1a1a1f; color: #fff; }
    &:hover { border-color: rgba(255, 255, 255, 0.25); color: rgba(255, 255, 255, 0.9); }
    &:focus { border-color: rgba(255, 255, 255, 0.35); }
`;

export const ListingName = styled.span`
    color: rgba(255, 255, 255, 0.9);
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
